import CreateTextLevelerView from "@features/tools/view/text-leveler-view/create-text-leveler-view";

const CreateTextLeveler = () => {
  return <CreateTextLevelerView />;
};

export default CreateTextLeveler;
